import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFeedbackModalVisible: false,
  page: "",
  params: {},
};

export const standaloneSlice = createSlice({
  name: "standalone",
  initialState,
  reducers: {
    setIsFeedbackModalVisible: (state, action) => {
      state.isFeedbackModalVisible = action.payload;
    },
    setStandalonePage: (state, action) => {
      state.page = action.payload;
    },
    setStandaloneParams: (state, action) => {
      state.params = action.payload;
    },
  },
});

export const getIsFeedbackModalVisible = (state) => state.standalone.isFeedbackModalVisible;
export const getStandalonePage = (state) => state.standalone.page;
export const getStandaloneParams = (state) => state.standalone.params;
export const { setIsFeedbackModalVisible, setStandalonePage, setStandaloneParams } = standaloneSlice.actions;

export default standaloneSlice.reducer;
